import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = {
  class: "stones",
  "aria-label": "Hauptnavigation"
}

import '@/assets/styles/navbar.css';

export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "navbar-header" }, [
      _createElementVNode("img", {
        class: "logo",
        src: "/logo.png",
        alt: "Firmenlogo"
      }),
      _createElementVNode("h1", null, "KFZ Musterwerkstatt")
    ], -1)),
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "stones-link"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Home", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/about",
        class: "stones-link"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Über uns", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/services",
        class: "stones-link"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Leistungen", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/products",
        class: "stones-link"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Produkte", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/career",
        class: "stones-link"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("Karriere", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/contact",
        class: "stones-link"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Kontakt", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})